import { useEffect } from 'react';
import { graphql, useFragment } from 'react-relay';

import { getCurrencyPreference } from '../../utils/preferredCurrency.ts';
import { setCurrency } from './currencyStore.ts';

import { type useSyncCurrencyStore_regionalInfo$key } from './__generated__/useSyncCurrencyStore_regionalInfo.graphql.ts';
import { type useSyncCurrencyStore_user$key } from './__generated__/useSyncCurrencyStore_user.graphql.ts';

const userUseSyncCurrencyStoreFragment = graphql`
    fragment useSyncCurrencyStore_user on User {
        preferences {
            currency
        }
    }
`;

const regionalInfoUseSyncCurrencyStoreFragment = graphql`
    fragment useSyncCurrencyStore_regionalInfo on RegionalInfo {
        currency
    }
`;

export function useSyncCurrencyStore({
    user: userRef,
    regionalInfo: regionalInfoRef,
}: {
    user?: useSyncCurrencyStore_user$key | null;
    regionalInfo?: useSyncCurrencyStore_regionalInfo$key | null;
}): void {
    const user = useFragment(userUseSyncCurrencyStoreFragment, userRef);
    const userCurrency = user?.preferences?.currency;
    const regionalInfo = useFragment(regionalInfoUseSyncCurrencyStoreFragment, regionalInfoRef);
    const regionalCurrency = regionalInfo?.currency;

    useEffect(() => {
        const currency = getCurrencyPreference({ userCurrency, regionalCurrency });
        setCurrency(currency);
    }, [userCurrency, regionalCurrency]);
}
